import { render, staticRenderFns } from "./ShareCollection.vue?vue&type=template&id=ad3c121e&scoped=true&lang=pug&"
import script from "./ShareCollection.vue?vue&type=script&lang=js&"
export * from "./ShareCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3c121e",
  null
  
)

export default component.exports